// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__EjL5O","approved":"Status_approved__3zTJf","rejected":"Status_rejected__352UB","expired":"Status_expired__3x1YL","label":"Status_label__2rCez"};